import React, { useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import CreateApplication from './CreateApplication';

/**
 * The /applications/new route. Opening another draft while the wizard is on
 * screen (continuing a different draft) keeps this route mounted, and the wizard reads its draft once, so a change of
 * draft in the URL remounts it. The wizard writing its own new draft's id
 * into the URL (state.savedHere) is the same application and keeps it
 * mounted, or what is being typed would be reloaded over.
 */
function CreateApplicationPage() {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const draft = searchParams.get('draft');
    const seen = useRef({ draft, key: 0 });
    if (draft !== seen.current.draft) {
        seen.current = {
            draft,
            key: location.state?.savedHere
                ? seen.current.key
                : seen.current.key + 1,
        };
    }
    return <CreateApplication key={seen.current.key} />;
}

export default CreateApplicationPage;
